<template>
	<div class="sidebar-header">
		<div class="sidebar-header-content">
			<img v-if="isMobile" @click="onClick" class="sidebar-header-content__close" src="@/assets/sidebar-icons/close-arrow.svg" alt="close sidebar"/>
			<h3 class="sidebar-header-content__title"> <slot name="title"/> </h3>
			<GenericMenu class="sidebar-header-content__menu" :items="menuItems"/>
		</div>
		<slot/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import GenericMenu from '../menu/GenericMenu.vue'

export default {
	props: {
		menuItems: Array,
		click: Function
	},
	components: { GenericMenu },
	computed: {
		...mapGetters('viewport', ['isMobile'])
	},
	methods: {
		...mapActions('sidebar', ['close']),
		onClick() {
			if (this.click) {
				this.click()
			} else {
				this.close()
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.sidebar-header {
	flex-shrink: 0;
	padding: 20px;

	&-content {
		display: flex;
		justify-content: space-between;
		align-items: center;

		&__close {
			cursor: pointer;
			flex-shrink: 0;
			height: 32px;
			width: 32px;
			margin-right: 15px;
			align-self: flex-start;
		}

		&__title {
			color: white;
			font-size: 1.4rem;
			line-height: 1.15;
			padding-right: 7px;
			margin-right: auto;
			display: flex;
			flex-direction: column;
			gap: 0.2rem;
		}
		&__menu {
			flex-shrink: 0;
		}
	}

	@include mobile-only {
		box-shadow: 0 0 8px 2px rgba(0,0,0,.45);

		&-content__close {
			transform: rotate(-90deg);
		}
	}
}
</style>
